import { useEffect, useMemo, useRef, useState } from "react";

export function usePagedList(filteredList, itemsPerPage) {
  // Stable empty-array reference when filteredList is null/undefined
  const list = useMemo(() => filteredList ?? [], [filteredList]);

  const pageCount = useRef(Math.ceil(list.length / itemsPerPage) || 1);
  const displayedPageButtons = useRef([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [pageItems, setPageItems] = useState([]);

  // list is a new array reference whenever the caller's filters change
  useEffect(() => {
    pageCount.current = Math.ceil(list.length / itemsPerPage) || 1;
    displayedPageButtons.current = [];
    setCurrentPage(0);
  }, [list, itemsPerPage]);

  useEffect(() => {
    pageCount.current = Math.ceil(list.length / itemsPerPage) || 1;

    const start = itemsPerPage * currentPage;
    setPageItems(list.slice(start, start + itemsPerPage));
  }, [list, currentPage, itemsPerPage]);

  const pagesToDisplay = () => {
    const pages = [];

    if (displayedPageButtons.current.length < 1) {
      for (let i = 0; i < pageCount.current && i <= 4; i++) {
        pages.push(i);
      }
    } else {
      const relativePageIndex = displayedPageButtons.current.indexOf(currentPage);

      if (relativePageIndex === 0) {
        for (let i = currentPage - 2; i <= currentPage + 2 && i >= 1; i++) {
          pages.push(i);
        }
      } else if (relativePageIndex === 4) {
        for (let i = currentPage - 2; i <= currentPage + 2 && i < pageCount.current; i++) {
          pages.push(i);
        }
      } else {
        return displayedPageButtons.current;
      }
    }

    displayedPageButtons.current = pages;

    return pages;
  };

  return { currentPage, setCurrentPage, pageItems, pageCount, pagesToDisplay };
}
